module.exports = __webpack_public_path__ + "static/img/manual-14.d92dc60.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/en/manual-14.png
// module id = V4Vc
// module chunks = 4